

const SwitchUserErrorContent = () => {
 return (
    <div className='row'>
          <div className="alert alert-danger pl-1 pr-2 ml-alert-err">
							<div className="alert-content error ml-1"></div>
							<span>
								<p>Error while impersonating user/account. Please check your input</p>
							</span>	
							
						</div>
    </div>
  );
}
export default SwitchUserErrorContent